import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import { space, textAlign } from 'styled-system';
import type { SpaceProps, TextAlignProps } from 'styled-system';

import { Grid, GridItem } from 'common/components/Grid';
import ReCaptchaDisclaimer from 'common/components/ReCaptchaDisclaimer';
import Separator from 'common/components/Separator';
import { BodyRegularBR2 } from 'common/components/Typography';

interface FooterLegalTextProps {
  legalText: string;
}

const TextContainer = styled.div<SpaceProps & TextAlignProps>`
  ${space};
  ${textAlign};
`;

const textContainerStyles: ComponentProps<typeof TextContainer> = {
  py: ['sp_16', null, 'sp_24', null],
  textAlign: 'center',
};

const separatorStyles = {
  mr: ['-16px', null, 'sp_0'],
  ml: ['-16px', null, 'sp_0'],
};

const FooterLegalText = ({ legalText }: FooterLegalTextProps) => (
  <Grid as="section" data-corgi-id="footer-legal-text">
    <GridItem>
      <Separator {...separatorStyles} />
      <TextContainer {...textContainerStyles}>
        <BodyRegularBR2>{legalText}</BodyRegularBR2>
        <ReCaptchaDisclaimer mt="sp_16" />
      </TextContainer>
    </GridItem>
  </Grid>
);

export default FooterLegalText;
